import gql from 'graphql-tag'

export const GET_NEWS_LIST = gql`
  query GetNewsList {
    newsItems {
      id
      name
      url
      enabled
      image {
        id
        name
        url
      }
    }
  }
`

export const GET_NEWS_BY_ID = gql`
  query GetNewsById($id: Int!) {
    newsItem(id: $id) {
      id
      name
      url
      enabled
      image {
        id
        name
        url
      }
    }
  }
`
